import { Backbone, _ } from "js/vendor";

const isConnected = _.extend({ connected: window.isOfflinePlayer ? false : window.navigator.onLine }, Backbone.Events);

function triggerIsOnlineChange(connected) {
    isConnected.connected = connected;
    isConnected.trigger("change");
}

if (!window.isOfflinePlayer) {
    window.addEventListener("offline", () => {
        triggerIsOnlineChange(false);
    });

    window.addEventListener("online", () => {
        triggerIsOnlineChange(true);
    });
}

export default isConnected;
